<style lang="less" scoped>
  .delivery-info{
    background-color: #f5f5f5;
    padding-bottom: 10px;
    display: none;
  }
</style>

<template>
  <div class="delivery-info">
    <delivery-phone :activeCode="activeCode"></delivery-phone>
  </div>
</template>
<script>
import deliveryPhone from './delivery_phone'

export default {
  props: ['activeCode'],
  data() {
    return {

    }
  },
  components: {
    deliveryPhone,
  },
}
</script>
